<template>
    <div>
        <div style="margin-top: 10px;">
            <p><h5>{{ $t('objects.details.service-plans.title') || 'Servicepläne' }}</h5></p>
        </div>
        <div class="table-responsive" style="margin-top: 10px;" v-if="rmsobject.service_plans">
            <table class="table table-striped table-sm">
                <thead>
                <tr>
                    <th>{{ $t('objects.details.service-plans.plan') || 'Serviceplan' }}</th>
                    <th>{{ $t('objects.details.service-plans.next-due') || 'Nächste Ausführung' }}</th>
                    <th>{{ $t('objects.details.service-plans.status') || 'Status' }}</th>
                    <th v-if="canManage" class="text-right">{{ $t('serviceplans.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="ap in rmsobject.service_plans" :key="ap.assignment_id">
                    <td>
                        {{ ap.service_plan ? ap.service_plan.name : '-' }}
                        <div v-if="ap.service_plan && ap.service_plan.description" class="small text-muted">
                            {{ ap.service_plan.description }}
                        </div>
                    </td>
                    <td>
                        {{ ap.next_due_at ? formatDate(ap.next_due_at) : '-' }}
                    </td>
                    <td>
                        <span v-if="isDue(ap)" class="badge badge-danger">{{ $t('objects.grid.service-required') }}</span>
                        <span v-else class="badge badge-success">{{ $t('serviceplans.status.ok') || 'Nicht fällig' }}</span>
                    </td>
                    <td v-if="canManage" class="text-right">
                        <template v-if="isDue(ap)">
                            <button v-if="ap.service_order_id" class="btn btn-sm btn-outline-primary" @click.prevent="viewOrder(ap.service_order_id)">
                                <i class="fas fa-external-link-alt mr-1"></i> {{ $t('serviceplans.actions.view-order') || 'Serviceauftrag anzeigen' }}
                            </button>
                            <button v-else class="btn btn-sm btn-success" @click.prevent="confirmService(ap)">
                                <i class="fas fa-file-medical mr-1"></i> {{ $t('serviceplans.actions.create-order') || 'Serviceauftrag anlegen' }}
                            </button>
                        </template>
                        <template v-else>
                            <button class="btn btn-sm btn-outline-warning" @click.prevent="triggerService(ap)">
                                <i class="fas fa-bolt mr-1"></i> {{ $t('serviceplans.actions.trigger') || 'Auslösen' }}
                            </button>
                        </template>
                    </td>
                </tr>
                <tr v-if="!rmsobject.service_plans || rmsobject.service_plans.length === 0">
                    <td colspan="4" class="text-center text-muted">
                        {{ $t('objects.form.serviceplans.no-assignments') }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "rms-objects-plans-tab",
        props: ['rmsobject'],
        computed: {
            canManage() {
                return typeof AshnetApp !== 'undefined' && AshnetApp.can && AshnetApp.can('serviceplan manage');
            }
        },
        methods: {
            formatDate(d) {
                if (!d) return '-';
                return moment(d).format(AshnetApp.dateFormat || 'DD.MM.YYYY');
            },
            viewOrder(id) {
                this.$router.push({ name: 'service-order-display', params: { orderid: id } });
            },
            isDue(ap) {
                const now = new Date();
                const next = ap && ap.next_due_at ? new Date(String(ap.next_due_at).replace(' ', 'T')) : null;
                const required = ap && ap.service_required_at ? new Date(String(ap.service_required_at).replace(' ', 'T')) : null;
                if (required && required <= now) return true;
                if (next && next <= now) return true;
                return false;
            },
            async confirmService(ap) {
                try {
                    const ok = await swal.fire({
                        title: ap.service_plan.name,
                        text: (this.$t('serviceplans.actions.create_order_confirm') || 'Möchten Sie für diesen Serviceplan einen Serviceauftrag anlegen?') + '?',
                        icon: 'question',
                        showCancelButton: true
                    });
                    if (!ok.value) return;

                    const res = await axios.post(`/api/rmsobjects/${this.rmsobject.id}/service-plan/${ap.assignment_id}/confirm`);

                    if (res.data && res.data.order_id) {
                        const view = await swal.fire({
                            icon: 'success',
                            title: this.$t('serviceplans.order_created') || 'Serviceauftrag wurde angelegt',
                            text: this.$t('serviceplans.view_order_now') || 'Möchten Sie den Auftrag jetzt öffnen?',
                            showCancelButton: true,
                            confirmButtonText: this.$t('general.yes') || 'Ja',
                            cancelButtonText: this.$t('general.no') || 'Nein'
                        });

                        if (view.value) {
                            this.viewOrder(res.data.order_id);
                            return;
                        }
                    } else {
                        await swal.fire({ icon: 'success', title: this.$t('serviceplans.confirm_success'), timer: 900 });
                    }

                    // Trigger reload in parent
                    this.$emit('reload');
                } catch (e) {
                    console.error(e);
                    swal.fire({ icon: 'error', text: this.$t('serviceplans.confirm_error') });
                }
            },
            async triggerService(ap) {
                try {
                    const ok = await swal.fire({
                        title: ap.service_plan.name,
                        text: (this.$t('serviceplans.actions.trigger_confirm') || 'Möchten Sie diesen Serviceplan jetzt fällig stellen?') + '?',
                        icon: 'warning',
                        showCancelButton: true
                    });
                    if (!ok.value) return;

                    await axios.post(`/api/rmsobjects/${this.rmsobject.id}/service-plan/${ap.assignment_id}/trigger`);
                    await swal.fire({ icon: 'success', title: this.$t('general.saved') || 'Gespeichert', timer: 900 });

                    // Trigger reload in parent
                    this.$emit('reload');
                } catch (e) {
                    console.error(e);
                    swal.fire({ icon: 'error', text: (e.response && e.response.data && e.response.data.message) || 'Error' });
                }
            }
        }
    }
</script>

<style scoped>

</style>
